import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatBot from '../components/ChatBot';
import ServicesHero from '../components/services/ServicesHero';
import ServiceDetailCard from '../components/services/ServiceDetailCard';
import DigitalCardProduct from '../components/services/DigitalCardProduct';
import Testimonials from '../components/Testimonials';
import { detailedServices } from '../data/servicesData';
import { Button } from '../components/ui/button';
import { Toaster } from '../components/ui/sonner';

export default function ServicesPage() {
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    document.title = 'Services & Pricing | iWurks360Digital Solutions';
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  const requestQuote = (service) => navigate('/', { state: { scrollTo: 'contact', service } });

  return (
    <div className="min-h-screen bg-white" data-testid="services-page">
      <Header />
      <main>
        <ServicesHero />
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-12">
          {detailedServices.slice(0, 6).map((s, i) => (
            <ServiceDetailCard key={s.slug} service={s} index={i} onQuote={requestQuote} />
          ))}
          <DigitalCardProduct />
          {detailedServices.slice(6).map((s, i) => (
            <ServiceDetailCard key={s.slug} service={s} index={i + 6} onQuote={requestQuote} />
          ))}
        </section>
        <Testimonials dark limit={3} />
        <section className="py-20 text-center px-4" style={{ backgroundColor: '#D97904' }}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
            Not sure which package fits?
          </h2>
          <p className="text-white/90 text-base md:text-lg max-w-xl mx-auto mb-8">
            Tell us your goals and we will build a custom plan, still at 27.5% below market rates.
          </p>
          <Button
            data-testid="services-custom-quote-btn"
            onClick={() => requestQuote('Custom Solution')}
            size="lg"
            className="bg-gray-900 text-white hover:bg-black rounded-full px-10 py-6 text-lg font-bold"
          >
            Request a Custom Quote
          </Button>
        </section>
      </main>
      <Footer />
      <ChatBot />
      <Toaster position="top-right" />
    </div>
  );
}
